import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_membership_points_RowClass} from '../../../dbschema';

export class MembershipPointsContainerModel extends BaseContainerModel {
  bl_crm_membership_points_txn_line: bl_crm_membership_points_RowClass = new bl_crm_membership_points_RowClass();
}
